var map = {
	"./layout_menu_menu1.png": 37072,
	"./layout_menu_menu2.png": 90571,
	"./layout_menu_menu3.png": 69442,
	"./layout_menu_menu4.png": 65789,
	"./layout_menu_menu5.png": 44660,
	"./layout_menu_menu6.png": 63567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16066;